// import Main from '@/view/main'

export default {
    path: 'appVersion',
    meta: {
      title: 'app版本管理'
    },
    component: () => import('@/components/parent-view'),
    name: 'version',
    children: [
        {
            path: 'list',
            meta: {
              title: '版本管理'
            },
            name: 'app-version-list',
            component: () => import('@/view/app/index.vue')
          }
    ]
  }
  


// WEBPACK FOOTER //
// ./src/router/routes/appVersion.js